import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const check_email = (
  emailTemplateId,
  locating,
  replace,
  subjectlocating,
  subjectreplace,
  toEmailUser,
  inputstring
) => {
  return api.post(`${ApiEndpointConstants.CHECKSENDEMAIL}`, {
    emailTemplateId,
    locating,
    replace,
    subjectlocating,
    subjectreplace,
    toEmailUser,
    inputstring,
  });
};
